import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { toast } from "react-toastify";
import CustomTextField from "../CustomTextField";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { es } from "date-fns/locale";
import { Controller } from "react-hook-form";

import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { DialogTitle, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { MuiFileInput } from "mui-file-input";
import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  cargarAdjuntoSolicitud,
  solucitudActualizacionCuentaBancaria,
} from "../../Redux/solicitudes";
import { UserAuth } from "../../context/AuthContext";
import TokenContext from "../../context/TokenContext";
import CustomSearchSelect from "../CustomSearchSelect";
import { useEffect } from "react";
import { useState } from "react";
import { obtenerBancos } from "../../Redux/autocompletados";
import CustomDateField from "../CustomDateField";

const opcionesTipoCuenta = [
  { value: "", label: "Seleccione una opción" },
  { value: "100000000", label: "Cuenta corriente" },
  { value: "100000001", label: "Caja de ahorro" },
];

const opcionesFormaPago = [
  { value: "", label: "Seleccione una opción" },
  { value: "100000000", label: "Cheque" },
  { value: "100000001", label: "Efectivo" },
  { value: "100000002", label: "Transferencia" },
];

const ModalSolicitudBancaria = ({ open, handleClose }) => {
  const token = useContext(TokenContext);
  const dispatch = useDispatch();
  const theme = useTheme();
  const { empleado } = UserAuth();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const estadoSolicitudCuentaBancaria = useSelector((store) => store.solicitudes.estadoSolicitudCuentaBancaria);
  const bancosSelector = useSelector((store) => store.autocompletados.bancos);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [bancos, setBancos] = useState([]);

  useEffect(() => {
    if (token) {
      dispatch(obtenerBancos(token));
    }
  }, []);

  const changeHandler = (newFile) => {
    setSelectedFiles(newFile);
  };

  useEffect(() => {
    if (bancosSelector?.length > 0) {
      const bancos = [];
      bancosSelector.forEach((item) => {
        const object = {
          value: item.new_bancoid,
          label: item.new_name,
        };
        bancos.push(object);
      });
      setBancos(bancos);
    }
  }, [bancosSelector]);

  const defaultValues = {
    empleado: empleado.empleadoid,
    asunto: null,
    fechaSolicitud: null,
    banco: null,
    tipoCuenta: null,
    nroCuenta: null,
    cbu: null,
    formaPago: null,
  };

  const validacionSchema = yup.object().shape({
    asunto: yup.string().required("Por favor indica el asunto."),
    // fechaSolicitud: yup.string().required("Required"),
    banco: yup.object({ value: yup.string().required("El banco es requerido") }),
    nroCuenta: yup.string().required("Por favor indica el número de cuenta."),
    cbu: yup.string().required("Por favor indica tu CBU."),
  });

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  });

  const { handleSubmit } = methods;

  const submitDatos = (datos) => {
    const formData = new FormData();
    for (let index = 0; index < selectedFiles.length; index++) {
      if (selectedFiles[index].size >= 15000000) {
        toast.error("El archivo no puede superar los 15 megas", {
          theme: "dark",
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setSelectedFiles([]);
        return;
      }
      let element = selectedFiles[index];
      formData.append(`body${index}`, element);
    }
    dispatch(solucitudActualizacionCuentaBancaria(token, datos))
      .then((id) => {
        handleClose();
        if (selectedFiles.length > 0 && id.length > 0) {
          dispatch(cargarAdjuntoSolicitud(token, formData, id, "cuentaBancaria_id"));
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle sx={{ justifyContent: "center", my: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            p: 1,
            color: (theme) => theme.palette.grey[500],
            "&:hover": {
              color: "red",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <FormProvider {...methods}>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="asunto"
                label="Asunto"
                rules={{ required: "Required!" }}
                // helperText="Por favor indica el asunto."
                req={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mb: 2, mt: 2 }}>
              <CustomDateField
                name="fechaSolicitud"
                label="Fecha de solicitud:"
                rules={{ required: "Required!" }}
                helperText="Indica la fecha de solicitud"
                req={true}
                className="custom-helper"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={bancos}
                type="text"
                req={true}
                name="banco"
                lab="Banco"
                // helperText="Por favor indica el banco."
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={opcionesTipoCuenta}
                type="text"
                name="tipoCuenta"
                lab="Tipo de cuenta"
              />
            </Grid>

            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="nroCuenta"
                label="N° de cuenta"
                rules={{ required: "Required!" }}
                // helperText="Por favor indica la institución."
                req={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomTextField
                Component={TextField}
                name="cbu"
                label="CBU"
                rules={{ required: "Required!" }}
                // helperText="Por favor indica la carrera."
                req={true}
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <CustomSearchSelect
                options={opcionesFormaPago}
                type="text"
                name="formaPago"
                lab="Forma de pago"
              />
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0, mt: 2 }}>
              <MuiFileInput
                value={selectedFiles}
                multiple
                label="Adjuntar documento"
                onChange={changeHandler}
                fullWidth
              />
            </Grid>
            <Grid sx={{ px: 2, mb: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box sx={{ height: "100%" }}>
                  <WarningAmberIcon color="warning" sx={{ mr: 1 }} />
                </Box>
                <Box sx={{ height: "100%" }}>
                  <Typography>
                    El tamaño máximo permitido por archivo es de 15 MB
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                // sx={buttonSx}
                disabled={estadoSolicitudCuentaBancaria === "LOADING"}
                onClick={handleSubmit(submitDatos)}
              >
                Enviar
              </Button>
            </Grid>
          </FormProvider>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ModalSolicitudBancaria;
